import React from 'react';

import useReportQueryParams from '../../../hooks/use-report-query-params';
import EngagementCards from './EngagementCards';
import OverallCards from './OverallCards';

const KeyboardingClassroomReport: React.FC = () => {
  const [reportParams] = useReportQueryParams();

  if (!reportParams.entityId) return null;

  return (
    <>
      <OverallCards />
      <EngagementCards />
    </>
  );
};

export default KeyboardingClassroomReport;
